export const UPLOAD_DAILY_RATES = {
  START: "UPLOAD_DAILY_RATES.START",
  SUCCESS: "UPLOAD_DAILY_RATES.SUCCESS",
  ERROR: "UPLOAD_DAILY_RATES.ERROR",
};

export const TOAST = {
  RESET: 'RESET_TOAST',
};
